import { workList } from "../common/Helper";
import line from "../../assets/img/line.png";
const HowItWork = () => {
  return (
    <>
      <div className="w-full 2xl:max-w-[1240px] container mx-auto pb-[140px] py-24 max-lg:py-20 max-md:py-14 max-xl:px-4">
        <div className="flex items-center gap-[31px] justify-between pt-[50px] max-lg:pt-10 max-md:pt-6 max-lg:flex-wrap max-lg:justify-center">
          {workList.map((item, index) => (
            <div
              key={index}
              className="flex items-center gap-[31px] w-full sm:max-w-[40%]"
            >
              <div className="flex flex-col items-center w-full">
                <div className="flex items-center justify-center">
                  <span>{item.icon}</span>
                </div>
                <h3 className="font-semibold text-2xl leading-[130%] text-[#010101] pt-5 uppercase">
                  {item.title}
                </h3>
                <p className="font-normal text-center text-base leading-[160%] text-black/90 opacity-70 pt-3">
                  {item.description}
                </p>
                <p className="font-normal text-center text-base leading-[160%] text-black/90 opacity-70 pt-1">
                  {item.description2}
                </p>
              </div>
              {index !== workList.length - 1 && (
                <img
                  src={line}
                  alt="line"
                  width={1}
                  height={243}
                  className="pointer-events-none h-[243px] max-lg:hidden"
                  unoptimized
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default HowItWork;
